import React from 'react';
import { motion } from 'framer-motion';

export function TeamHeader() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="text-center mb-16"
    >
      <h2 className="text-4xl font-bold text-gray-900">Our Team</h2>
      <p className="text-xl text-gray-600 max-w-2xl mx-auto">
        Meet the experts driving climate finance and sustainability initiatives in Africa.
      </p>
    </motion.div>
  );
}